import { FormattedMessage, useIntl } from 'react-intl'

import {
  ENTER_LABEL_MAP,
  IDENTIFIER_TYPE_OPTIONS,
  PLACEHOLDER_MAP,
} from './PublicRequestReturnLabel.constants'
import type {
  DeviceIdentifierBlockProps,
  DeviceIdentifierTypeEnum,
} from './PublicRequestReturnLabel.types'

export const DeviceIdentifierBlock = (props: DeviceIdentifierBlockProps) => {
  const { index, showRemove, onRemove, register, setValue, selectedType } =
    props
  const intl = useIntl()

  const handleTypeChange = (type: DeviceIdentifierTypeEnum) => {
    setValue(`devices.${index}.value`, '')
    setValue(`devices.${index}.identifierType`, type)
  }

  const title = showRemove ? (
    <FormattedMessage
      id="PublicRequestReturnLabel_deviceIdentifier_titleNumbered"
      values={{ number: index + 1 }}
    />
  ) : (
    <FormattedMessage id="PublicRequestReturnLabel_deviceIdentifier_title" />
  )

  const stepTwoLabel = selectedType
    ? intl.formatMessage({ id: ENTER_LABEL_MAP[selectedType] })
    : ''

  const placeholder = selectedType
    ? intl.formatMessage({ id: PLACEHOLDER_MAP[selectedType] })
    : intl.formatMessage({
        id: 'PublicRequestReturnLabel_deviceIdentifier_placeholderDisabled',
      })

  return (
    <div className="DeviceIdentifierBlock">
      <div className="DeviceIdentifierBlock-header">
        <h3 className="DeviceIdentifierBlock-title">{title}</h3>
        {showRemove && (
          <button
            aria-label={intl.formatMessage({
              id: 'PublicRequestReturnLabel_deviceIdentifier_removeDevice',
            })}
            className="DeviceIdentifierBlock-remove"
            onClick={onRemove}
            type="button"
          >
            &times;
          </button>
        )}
      </div>

      <div className="DeviceIdentifierBlock-content">
        <div className="DeviceIdentifierBlock-step">
          <label className="DeviceIdentifierBlock-stepLabel">
            1.{' '}
            <FormattedMessage id="PublicRequestReturnLabel_deviceIdentifier_selectType" />
          </label>
          <div className="DeviceIdentifierBlock-radioGroup">
            {IDENTIFIER_TYPE_OPTIONS.map(option => (
              <label
                key={option.type}
                className="DeviceIdentifierBlock-radioLabel"
              >
                <input
                  checked={selectedType === option.type}
                  className="DeviceIdentifierBlock-radio"
                  name={`device-type-${index}`}
                  onChange={() => handleTypeChange(option.type)}
                  type="radio"
                />
                <span>
                  <FormattedMessage id={option.labelId} />
                </span>
              </label>
            ))}
          </div>
        </div>

        <div
          className={`DeviceIdentifierBlock-step ${selectedType ? '' : 'DeviceIdentifierBlock-step--disabled'}`}
        >
          <label
            className="DeviceIdentifierBlock-stepLabel"
            htmlFor={`device-value-${index}`}
          >
            2. {stepTwoLabel}
          </label>
          <input
            {...register(`devices.${index}.value`)}
            autoComplete="off"
            className="DeviceIdentifierBlock-input"
            disabled={!selectedType}
            id={`device-value-${index}`}
            placeholder={placeholder}
            type="text"
          />
        </div>
      </div>
    </div>
  )
}
